namespace TabAurous.Sales {
    export namespace ApprovalOutReturnService {
        export const baseUrl = 'Sales/ApprovalOutReturn';

        export declare function Create(request: Serenity.SaveRequest<ApprovalOutReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalOutReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PostedTransIdList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function APIImportApprovalInReturns(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/ApprovalOutReturn/Create",
            Update = "Sales/ApprovalOutReturn/Update",
            Delete = "Sales/ApprovalOutReturn/Delete",
            Retrieve = "Sales/ApprovalOutReturn/Retrieve",
            List = "Sales/ApprovalOutReturn/List",
            PartyList = "Sales/ApprovalOutReturn/PartyList",
            PostedTransIdList = "Sales/ApprovalOutReturn/PostedTransIdList",
            APIImportApprovalInReturns = "Sales/ApprovalOutReturn/APIImportApprovalInReturns"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PartyList', 
            'PostedTransIdList', 
            'APIImportApprovalInReturns'
        ].forEach(x => {
            (<any>ApprovalOutReturnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
